import { HttpErrorResponse } from '@angular/common/http';
import { ValidationError } from '../entities/common/validation.entity';

export const ExtractValidationErrors: (err: HttpErrorResponse) => string[] | undefined = (
    err: HttpErrorResponse
): string[] | undefined => {
    if (err.error && err.error.Errors) {
        return err.error.Errors.map((validationError: ValidationError) => validationError.Message);
    }

    return undefined;
};
